<template>
  <div class="linexo linexo-scoping light-theme" :class="linexoScopingClasses">
    <slot name="intro"></slot>
    <div class="linexo-scoping__main" :class="themeStore.appClasses">
      <InfoModal
        ref="infoModal"
        :modal-component="modal?.key"
        :modal-data="modal?.data"
        :visible="showModal"
        v-bind="modal?.props"
        @onCloseModal="uiStore.hideModal()"
        @onConfirmModal="
          () => {
            if (hasOnConfirm(modal?.data)) {
              modal!.data!.onConfirm?.()
            }
          }
        "
      />
      <slot></slot>
    </div>
    <slot name="outro"></slot>
  </div>
</template>
<script lang="ts" setup>
import { useThemeStore } from '@/stores/theme.store'
import { useUiStore } from '@/stores/ui.store'
import { hasOnConfirm } from '@/ts/guards/modal.type-guards'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'
import InfoModal from '@/components/modal/content/info/InfoModal.vue'

type Props = {
  boxedMode?: boolean
}

const props = withDefaults(defineProps<Props>(), { boxedMode: false })

const themeStore = useThemeStore()

const uiStore = useUiStore()
const { modal, showModal } = storeToRefs(uiStore)

const linexoScopingClasses = computed(() => ({
  'linexo-scoping--boxed-mode': props.boxedMode
}))
</script>
<style lang="scss" scoped>
@import './linexo-scoping.scss';
</style>
